export const ReservedProperties = ["AAAAAAAA", "AAAA0000"];
export const PropertyStatus = {
  ACTIVE: "Active",
  BLOCKED: "Blocked",
  INACTIVE: "Inactive",
};
